import { TipoValor, TipoVoucher } from './enum';

export class Voucher {
  id: number;
  idCliente: number;
  tipoVoucher: TipoVoucher = TipoVoucher.Normal;
  descricao: string;
  valorMinimoPedido: number;
  prazoValidade: number;
  tipoValor: TipoValor;
  tipoValorDescricao: string;
  valor: number;
  codigo: string;
  beneficios: string;
  condicoes: string;
  idCupom: string;
  dataCriacao: Date;
  validoAte: Date;
  estaValido: boolean;
  reutilizavel: boolean;
  excluirCupomDesconto: boolean = false;
  visualizavel: boolean;
  perfis: number[];
}
